// Third payty and libraries
import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Spinner,
  Modal,
  ListGroup,
  Alert,
} from "react-bootstrap";
import Select from "react-select";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLazyQuery, useMutation } from "@apollo/client";

// constant
import {
  GET_HAL_BRANCHS,
  GET_JNT_PROVINCES,
  GET_MIXAY_DROP_SHIPS_V2,
  GET_MIXAY_DROPSHIPS,
  GET_MIXAY_PROVINCES,
  GET_MIXAY_PROVINCES_V2,
  GET_SHOP_ADDRESS_DEFAULT,
} from "../../../graphql/shop/shopAddress/query";
import {
  COLOR_APP,
  HAL_KEY,
  JNT_KEY,
  K_LOCAL_STORAGE_SHOP_DATA,
  K_LOCAL_STORAGE_SHOP_SETTING_DATA,
  LOGISTICS_DATAS,
  MIXAY_KEY,
} from "../../../constants";
import { CREATE_PREORDER_LOGICTICS } from "../../../graphql/logistic/mutation";

// icons
import {
  MdCancel,
  MdOutlineCheckCircle,
  MdRadioButtonChecked,
} from "react-icons/md";
import _ from "lodash";
import { CREATE_SHOP_ADDRESS } from "../../../graphql/shop/shopAddress/mutation";
import { FaSave } from "react-icons/fa";
import { checkLogoLogictics, convertLogicticsName } from "../../../helpers";
import { errorSwal } from "../../../helpers/sweetalert";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  shopName: Yup.string().required("ຕ້ອງປ້ອນຊື່ຜູ້ຝາກ ຫຼື ຊື່ຮ້ານກ່ອນ!"),
  shopPhone: Yup.string()
    .required("ຕ້ອງປ້ອນເບີໂທລະສັບກ່ອນ!")
    .matches(/^[0-9]{8}$/, "ເບີໂທ ຕ້ອງປະກອບດ້ວຍ 8 ຕົວເລກເທົ່ານັ້ນ"),
  receiverName: Yup.string().required("ຕ້ອງປ້ອນຊື່ຜູ້ຝາກກ່ອນ!"),
  receiverPhone: Yup.string()
    .required("ຕ້ອງປ້ອນເບີໂທຜູ້ຮັບກ່ອນ!")
    .matches(/^[0-9]{8}$/, "ເບີໂທ ຕ້ອງປະກອບດ້ວຍ 8 ຕົວເລກເທົ່ານັ້ນ"),
  length: Yup.number()
    .required("ກະລຸນາປ້ອນຄວາມຍາວ")
    .min(1, "ຄວາມຍາວຕ້ອງຫຼາຍກວ່າ 0")
    .max(1000, "ຄວາມຍາວບໍ່ຄວນເກີນ 1000cm")
    .typeError("ກະລຸນາປ້ອນຕົວເລກເທົ່ານັ້ນ"),
  width: Yup.number()
    .required("ກະລຸນາປ້ອນຄວາມກ້ວາງ")
    .min(1, "ຄວາມກ້ວາງຕ້ອງຫຼາຍກວ່າ 0")
    .max(1000, "ຄວາມກ້ວາງບໍ່ຄວນເກີນ 1000cm")
    .typeError("ກະລຸນາປ້ອນຕົວເລກເທົ່ານັ້ນ"),
  height: Yup.number()
    .required("ກະລຸນາປ້ອນຄວາມສູງ")
    .min(1, "ຄວາມສູງຕ້ອງຫຼາຍກວ່າ 0")
    .max(1000, "ຄວາມສູງບໍ່ຄວນເກີນ 1000cm")
    .typeError("ກະລຸນາປ້ອນຕົວເລກເທົ່ານັ້ນ"),
  weight: Yup.number()
    .required("ກະລຸນາປ້ອນນ້ຳຫນັກ")
    .min(0.1, "ນ້ຳຫນັກຕ້ອງຫຼາຍກວ່າ 0")
    .max(300, "ນ້ຳຫນັກບໍ່ຄວນເກີນ 300kg")
    .typeError("ກະລຸນາປ້ອນຕົວເລກເທົ່ານັ້ນ"),
});

export default function SelectDeliveryDailog({
  openSelect,
  onCloseSelectModal,
  orderGroupdataProps,
  _filter,
  logicticsName,
}) {
  const localShop = localStorage.getItem(K_LOCAL_STORAGE_SHOP_DATA);
  let shopData = JSON.parse(localShop);
  const localSetting = localStorage.getItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA);
  let settingData = JSON.parse(localSetting);

  //* กรองขนส่งที่ปิดสวิตช์ไว้ในหน้า Setting ออกจาก dropdown
  //* ซ่อนเฉพาะตอนเป็น false (ปิดสวิตช์จริง) เท่านั้น
  //* ถ้าเป็น null/undefined (ร้านยังไม่เคยตั้งค่า หรือ ANUSITH ที่ไม่มีสวิตช์) ให้แสดงเหมือนเดิม
  const enabledLogicsticsOptions = useMemo(() => {
    const isOpenByKey = {
      [HAL_KEY]: settingData?.halIsOpen,
      [MIXAY_KEY]: settingData?.mxIsOpen,
      [JNT_KEY]: settingData?.jntIsOpen,
    };
    return logicsticsOptions.filter(
      (option) => isOpenByKey[option?.value] !== false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingData?.halIsOpen, settingData?.mxIsOpen, settingData?.jntIsOpen]);

  // state
  const [logicticsAddress, setLogicticsAddress] = useState({
    provinces: [],
    districts: [],
    villages: [],
    branchDatas: [],
  });
  const [provinceOption, setProvinceOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);
  const [desProvinceOption, setDesProvinceOption] = useState([]);
  const [desDistrictOption, setDesDistrictOption] = useState([]);
  const [desVillageOption, setDesVillageOption] = useState([]);
  const [formState, setFormState] = useState({
    _province: "",
    _district: "",
    _branchName: "",
    branchOption: {},
  });
  const [healthCheck, setHealthCheck] = useState({
    2: false,
    3: false,
    4: false,
  });
  const [depositorDatas, setDepositorDatas] = useState([]);
  const [isAddAddresss, setIsAddAddress] = useState(false);
  const [deliveryData, setDeliveryData] = useState();
  const [destinationAddress, setDestinationAddress] = useState({
    desProvince: "",
    desDistrict: "",
    desBranch: "",
  });
  const [isValidate, setIsValidate] = useState({
    errorSenderAddress: false,
    errorReceivePro: false,
    errorReceiveDis: false,
    errorReceiveBranch: false,
  });
  const [completedPreOrder, setCompletedPreOrder] = useState({
    status: false,
    isError: false,
    message: "",
  });
  const [shipmentPayType, setShipmentPayType] = useState("CDC");
  const [isMatchDelivery, setIsMatchDelivery] = useState({
    match: false,
    addressReceiver: {},
  });

  const [activeLogictics, setActiveLogictics] = useState();
  const [prepareMixayDropships, setPrePareMixayDropships] = useState([]);
  const [mixayDropShipByProvince, setMixayDropShipByProvince] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [isCorrectBranchOption, setIsCorrectBranchOption] = useState({
    pv: false,
    dt: false,
    br: false,
  });
  const [isReceiveAddress, setIsReceiveAddress] = useState(false);
  const [disabledSave, setDisabledSave] = useState(false);

  // apollo client query
  const [
    getHalBranchDatas,
    { data: halBranchDatas, loading: loadingBanchHal },
  ] = useLazyQuery(GET_HAL_BRANCHS, { fetchPolicy: "network-only" });
  const [
    getShopAddress,
    { data: shopAddressDefault, loading: loadingShopAddress },
  ] = useLazyQuery(GET_SHOP_ADDRESS_DEFAULT, { fetchPolicy: "network-only" });
  const [
    getMixayProvinces,
    { data: mixayProvinces, loading: loadingProvinceMixay },
  ] = useLazyQuery(GET_MIXAY_PROVINCES, { fetchPolicy: "network-only" });
  const [
    getMixayDropShips,
    { data: mixayDropShips, loading: loadingDropshipMixay },
  ] = useLazyQuery(GET_MIXAY_DROPSHIPS, { fetchPolicy: "network-only" });

  // apolloo client mutaion
  const [createPreOrderDelivery, { loading: loadingCreatePreOrder }] =
    useMutation(CREATE_PREORDER_LOGICTICS);
  const [createShopAddressDefault, { loading: loadingAddShopAddresss }] =
    useMutation(CREATE_SHOP_ADDRESS);

  //TODO MIXAY V2
  const [
    getMixayProvincesV2,
    { data: mixayProvincesV2, loading: loadingProvinceMixayV2 },
  ] = useLazyQuery(GET_MIXAY_PROVINCES_V2, { fetchPolicy: "network-only" });
  const [getMixayDropShipsV2, { loading: loadingDropShipMixayV2 }] =
    useLazyQuery(GET_MIXAY_DROP_SHIPS_V2, { fetchPolicy: "network-only" });

  //TODO JNT
  const [getJntProvinces, { data: jntProvinces, loading: loadingProvinceJnt }] =
    useLazyQuery(GET_JNT_PROVINCES, { fetchPolicy: "network-only" });

  // useEffect
  useEffect(() => {
    if (halBranchDatas) {
      // Set logistics address from the response data
      setLogicticsAddress({
        provinces: halBranchDatas?.getHalBranchList?.provinces,
        districts: halBranchDatas?.getHalBranchList?.districts,
        villages: halBranchDatas?.getHalBranchList?.villages,
        branchDatas: JSON.parse(halBranchDatas?.getHalBranchList?.branchDatas),
      });

      // Map province options for react-select
      const provinceOptions = halBranchDatas?.getHalBranchList?.provinces.map(
        (province) => ({
          value: province.id,
          label: province.name,
        }),
      );
      setProvinceOption(provinceOptions);
      setDesProvinceOption(provinceOptions);

      // Map village options for react-select
      const villageOptions = halBranchDatas?.getHalBranchList?.villages.map(
        (village) => ({
          value: village.id,
          label: village.name,
        }),
      );
      setVillageOption(villageOptions);
    }
    if (!_.isEmpty(mixayProvincesV2)) {
      // let mixayProvinceOptions = mixayProvinces?.getMixayProvinces?.provinces.map((province) => ({
      //     value: province.id,
      //     label: province.name,
      // }));
      let mixayProvinceOptions =
        mixayProvincesV2?.getMixayProvincesV2?.provinces.map((province) => ({
          value: province?.id,
          label: province?.name,
        }));
      setProvinceOption(mixayProvinceOptions);
      setDesProvinceOption(mixayProvinceOptions);
    }
    if (!_.isEmpty(jntProvinces)) {
      setLogicticsAddress((prev) => ({
        ...prev,
        provinces: jntProvinces?.getJntProvinces?.provinces,
        districts: jntProvinces?.getJntProvinces?.districts,
        branchDatas: JSON.parse(
          jntProvinces?.getJntProvinces?.branchDatas || "[]",
        ),
      }));

      const jntProvinceOptions = jntProvinces?.getJntProvinces?.provinces.map(
        (province) => ({
          value: province?.id,
          label: province?.name,
        }),
      );
      setProvinceOption(jntProvinceOptions);
      setDesProvinceOption(jntProvinceOptions);
    }
    if (
      healthCheck[3] &&
      (!_.isEmpty(destinationAddress?.desBranch) || isReceiveAddress)
    ) {
      setHealthCheck((prev) => ({ ...prev, 4: true }));
    }
  }, [halBranchDatas, mixayProvincesV2, jntProvinces]);

  useEffect(() => {
    let _receiverAddress = orderGroupdataProps?.orderDelivery?.receiver;
    setIsMatchDelivery({
      match: orderGroupdataProps?.orderDelivery?.match,
      addressReceiver: _receiverAddress,
    });

    setShipmentPayType(orderGroupdataProps?.orderDelivery?.shipmentPayType);

    const deliveryName = orderGroupdataProps?.orderDelivery?.delivery;
    //* CHECK IF ADDRESS IS CORRECT
    switch (deliveryName) {
      case HAL_KEY:
        if (settingData?.halIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      case MIXAY_KEY:
        if (settingData?.mxIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      case JNT_KEY:
        if (settingData?.jntIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      default:
        break;
    }

    if (openSelect && onCloseSelectModal) {
      fetchShopAddressDefault(shopData?.id, deliveryName);
      setIsReceiveAddress(false);
    }
  }, [orderGroupdataProps?.orderDelivery]);

  useEffect(() => {
    if (shopAddressDefault?.shopAddressShopId?.data) {
      setDepositorDatas(shopAddressDefault.shopAddressShopId.data);
    }
  }, [shopAddressDefault]);

  useEffect(() => {
    if (!depositorDatas?.length) return;

    const setDefaultAddress = () => {
      const shopAddress =
        orderGroupdataProps?.orderDelivery?.sender?.shopAddress;
      const selectedDefault = depositorDatas.find(
        (data) => data.id === shopAddress,
      );

      if (selectedDefault) {
        setDeliveryData(selectedDefault);
        setDestinationAddress({
          desBranch: selectedDefault.branch,
          desProvince: selectedDefault.province,
          desDistrict: selectedDefault.district,
        });
        setHealthCheck((prev) => ({ ...prev, 2: true, 3: true, 4: true }));
      }
    };

    const timeoutId = setTimeout(setDefaultAddress, 100);

    return () => clearTimeout(timeoutId); // Clean up timeout on unmount or when dependencies change
  }, [depositorDatas]);

  useEffect(() => {
    if (!_.isEmpty(isMatchDelivery?.addressReceiver)) {
      handleReceiveAddress();
    }
  }, [isMatchDelivery?.addressReceiver]);

  // get shop address
  const fetchShopAddressDefault = async (shopId, deliveryName) => {
    try {
      if (loadingShopAddress && shopAddressDefault) return;
      let where = { shop: shopId };
      if (deliveryName) where = { ...where, deliveryName };
      await getShopAddress({
        variables: { where },
      });
    } catch (error) {
      console.log(error);
    }
  };

  //TODO create shop address default
  const confirmPreOrders = async (values) => {
    const invalidAddress = depositorDatas.find(
      (data) => data.id === deliveryData?.id,
    );
    if (!invalidAddress) {
      errorSwal("(1) ຂໍ້ມູນຕົ້ນທາງບໍ່ຖືກ ກະລຸນາເລືອກໃຫມ່");
      return;
    }
    const localShopId = localStorage.getItem("SHOP");
    if (_.isEmpty(deliveryData)) {
      setIsValidate((preError) => ({
        ...preError,
        errorSenderAddress: true,
      }));
      return;
    }
    if (_.isEmpty(destinationAddress)) {
      setIsValidate((preError) => ({
        ...preError,
        errorReceivePro: true,
        errorReceiveDis: true,
        errorReceiveBranch: true,
      }));
      return;
    }

    if (
      (!isCorrectBranchOption.pv ||
        !isCorrectBranchOption.dt ||
        !isCorrectBranchOption.br) &&
      !isReceiveAddress
    ) {
      //* ບອກໃຫ້ຊັດວ່າຂາດຊ່ອງໃດ — ເມື່ອກ່ອນຂຶ້ນແຕ່ swal ລວມ "ແຂວງ, ເມືອງ, ບ້ານ ບໍ່ຖືກ"
      //* ຜູ້ໃຊ້ທີ່ເລືອກ "ເມືອງ" ໄປແລ້ວຈຶ່ງງົງວ່າເປັນຫຍັງຍັງບອກໃຫ້ເລືອກເມືອງອີກ
      //* ⚠️ ບໍ່ໄດ້ຫຼຸດຄວາມເຂັ້ມຂອງການກວດ — ເງື່ອນໄຂຂ້າງເທິງຄືເກົ່າທຸກຢ່າງ
      setIsValidate((preError) => ({
        ...preError,
        errorReceivePro: !isCorrectBranchOption.pv,
        errorReceiveDis: !isCorrectBranchOption.dt,
        errorReceiveBranch: !isCorrectBranchOption.br,
      }));
      errorSwal("(3) ຂໍ້ມູນປາຍທາງ ແຂວງ, ເມືອງ, ບ້ານ ບໍ່ຖືກ  ກະລຸນາເລືອກໃຫມ່");
      return;
    }
    try {
      if (loadingCreatePreOrder) return;
      if (_.isEmpty(shipmentPayType)) {
        errorSwal("(2) ກະລຸນາເລືອກປະເພດການເກັບເງິນ!");
        return;
      }
      let _where = {
        orderGroupId: orderGroupdataProps?.id,
        isChange: true, // ກໍລະນີມີການປ່ຽນແປງ
        isCustom: _.isEmpty(orderGroupdataProps?.orderDelivery?.delivery)
          ? true
          : false,
      };
      let _data = {
        shop: localShopId,
      };
      // parcel
      if (values?.length || values?.width || values?.height || values?.weight) {
        const length = parseFloat(
          values.length ? values.length.toString().replace(/,/g, "") : 0,
        );
        const width = parseFloat(
          values.width ? values.width.toString().replace(/,/g, "") : 0,
        );
        const height = parseFloat(
          values.height ? values.height.toString().replace(/,/g, "") : 0,
        );
        const weight = parseFloat(
          values.weight ? values.weight.toString().replace(/,/g, "") : 0,
        );
        const parcel = {
          dimension_length: length + width + height,
          weight: weight,
          length: values?.length,
          width: values?.width,
          height: values?.height,
        };

        _data = {
          ..._data,
          parcels: [parcel],
        };
      }

      if (!_.isEmpty(orderGroupdataProps?.orderDelivery?.id)) {
        _where = {
          ..._where,
          id: orderGroupdataProps?.orderDelivery?.id,
        };
      }
      if (!_.isEmpty(deliveryData)) {
        _where = {
          ..._where,
          delivery: deliveryData?.deliveryName,
        };
        _data = {
          ..._data,
          sender: {
            shopAddress: deliveryData?.id,
            fullName: deliveryData?.fullName,
            tel: deliveryData?.shopTel,
            province: deliveryData?.province,
            district: deliveryData?.district,
            village: deliveryData?.village || deliveryData?.branch,
            branch: deliveryData?.branch,
            branchCode: deliveryData?.branchCode || "",
            sender_branch_id: deliveryData?.sender_branch_id || 0,
            deliveryName: deliveryData?.deliveryName,
            address: deliveryData?.address || "",
            postcode: deliveryData?.postcode || "",
            dropship_end: deliveryData?.dropship_end || 0,
          },
        };
      }

      if (!_.isEmpty(destinationAddress)) {
        // if end user input the data to order or confirm order success to set data to receiver
        if (
          !_.isEmpty(orderGroupdataProps?.orderDelivery?.receiver) &&
          isReceiveAddress
        ) {
          let _desBranchDatas = orderGroupdataProps?.orderDelivery?.receiver;
          const newSenderAddress =
            deliveryData?.branch +
            "-" +
            deliveryData?.district +
            "-" +
            deliveryData?.province;
          _data = {
            ..._data,
            receiver: {
              userAddress: _desBranchDatas?.userAddress,
              userId: _desBranchDatas?.userId,
              fullName: values?.receiverName,
              tel: values?.receiverPhone,
              province: _desBranchDatas?.province ?? desProvinceOption,
              district: _desBranchDatas?.district,
              village: _desBranchDatas?.village,
              branch: _desBranchDatas?.branch,
              branchCode: _desBranchDatas?.branchCode || "",
              receive_branch_id: _desBranchDatas?.receive_branch_id || 0,
              deliveryName: deliveryData?.deliveryName,
              address: _desBranchDatas?.address,
              postcode: _desBranchDatas?.postcode || "",
            },
          };
          if (_.isEmpty(_data?.sender?.address)) {
            _data = {
              ..._data,
              sender: {
                ..._data?.sender,
                address: newSenderAddress,
              },
            };
          }
          _where = {
            ..._where,
            id: orderGroupdataProps?.orderDelivery?.id, // order delivery id
          };
        } else {
          let _desBranchDatas = JSON.parse(destinationAddress?.desBranch);
          const receiveUser = orderGroupdataProps?.orderDelivery?.receiver;
          // MIXAY เก็บรหัสสาขาไว้ในช่อง branchCode
          // J&T ก็ใช้ช่องเดียวกัน — value คือ deliveryBranchCode 6 หลัก ("010101")
          // หลังบ้านอ่านต่อที่ helper.js (bodyOrderDeliveryJnt) แล้วส่งให้ jnt.control.js
          let branchCode =
            deliveryData?.deliveryName === "MIXAY" ||
            deliveryData?.deliveryName === JNT_KEY
              ? _desBranchDatas?.branchCode || _desBranchDatas?.value || ""
              : "";
          const receive_branch_id =
            deliveryData?.deliveryName === "HAL"
              ? _desBranchDatas?.value
              : null;
          const senderAddress =
            deliveryData?.branch +
            "-" +
            deliveryData?.district +
            "-" +
            deliveryData?.province;

          _data = {
            ..._data,
            receiver: {
              userAddress: "",
              userId: "",
              fullName: values?.receiverName,
              tel: values?.receiverPhone,
              province: destinationAddress?.desProvince,
              district: destinationAddress?.desDistrict,
              village: _desBranchDatas?.label ?? "", //receiveUser?.village ?? _desBranchDatas?.label ?? "",
              branch: _desBranchDatas?.label ?? destinationAddress?.desBranch,
              branchCode: branchCode,
              receive_branch_id: receive_branch_id || 0,
              deliveryName: deliveryData?.deliveryName,
              address: formState?.branchOption?.address_detail
                ? formState?.branchOption?.address_detail
                : receiveUser?.village ||
                  _desBranchDatas?.label +
                    "-" +
                    destinationAddress?.desDistrict +
                    "-" +
                    destinationAddress?.desProvince,
              postcode: formState?.branchOption?.postcode ?? "",
            },
          };
          if (_.isEmpty(_data?.sender?.address)) {
            _data = {
              ..._data,
              sender: {
                ..._data?.sender,
                address: senderAddress,
              },
            };
          }
        }
      }

      if (!_.isEmpty(shipmentPayType)) {
        _data = {
          ..._data,
          shipment_pay_type: shipmentPayType,
        };
      }

      await createPreOrderDelivery({
        variables: {
          where: _where,
          data: _data,
        },
      }).then((response) => {
        if (
          response?.data?.confirmPreOrderDelivery?.message ===
          "CREATE_PRE_ORDER_COMPLETED"
        ) {
          setCompletedPreOrder({
            status: true,
            message: "ສ້າງສຳເລັດ",
          });
          // Fetch new data
          _filter();
          setIsReceiveAddress(false);
        } else {
          errorSwal("ຂໍອະໄພ ບໍ່ສາມາດສ້າງຂົນສົ່ງໄດ້(ມີຂໍພີດພາດຢູ່ເບື່ອງຫລັງ)!");
        }
      });
    } catch (error) {
      console.log("confirmPreOrders error: ", error);
      errorSwal("ບັນທຶກຫຼົ້ມແຫຼວ!");
    }
  };

  // handle change get logictics
  const handleChange = (selectedOption, setFieldValue) => {
    setFieldValue("logistics", selectedOption);
    setIsValidate({
      alertLogictics: false,
    });
    setActiveLogictics(selectedOption?.value); // get active when select the logictics
    if (selectedOption?.value === HAL_KEY) {
      getHalBranchDatas();
    } else if (selectedOption?.value === MIXAY_KEY) {
      // getMixayProvinces();
      getMixayProvincesV2();
    } else if (selectedOption?.value === JNT_KEY) {
      getJntProvinces();
    } else {
      setProvinceOption([]);
      setDistrictOption([]);
      setVillageOption([]);
    }
  };

  // select province to filter district alls
  const onChangeProvince = (value) => {
    setFormState((prevState) => ({
      ...prevState,
      _province: value?.label,
    }));
    setIsCorrectBranchOption((prev) => ({ ...prev, pv: true }));
  };

  // get mixay dropships
  // const handleFectMixayDropshipAll = async (_name) => {
  //     try {
  //         await getMixayDropShips({
  //             variables: {
  //                 where: {
  //                     provinceName: _name,
  //                 },
  //             },
  //         }).then((response) => {
  //             if (!_.isEmpty(response?.data)) {
  //                 const _resDropship = JSON.parse(
  //                     response?.data?.getMixayDropships?.branchDatas
  //                 );

  //                 // Create a Set to store unique district names
  //                 const uniqueDistricts = new Set();

  //                 // Filter the districts and map them to the options format, ensuring each district name is unique
  //                 const provinceOptions = _resDropship
  //                     .filter((district) => {
  //                         const isUnique = !uniqueDistricts.has(district.dristric);
  //                         uniqueDistricts.add(district.dristric); // Add the district name to the set
  //                         return isUnique;
  //                     })
  //                     .map((district) => ({
  //                         value: district.id,
  //                         label: district.dristric,
  //                     }));

  //                 // Set the district options
  //                 setDesDistrictOption(provinceOptions);
  //                 setPrePareMixayDropships(_resDropship);
  //             }
  //         });
  //     } catch (error) {
  //         console.error("error", error);
  //     }
  // };

  // get mixay dropships
  const handleMixayDropShip = async (id) => {
    try {
      const response = await getMixayDropShipsV2({
        variables: {
          where: {
            // provinceName: _name,
            provinceId: id,
          },
        },
      });
      // .then((response) => {
      if (!_.isEmpty(response?.data)) {
        const _resDropShip = JSON.parse(
          response?.data?.getMixayDropShipsV2?.branchDatas,
        );

        // Create a Set to store unique district names
        const uniqueDistricts = new Set();

        // Filter the districts and map them to the options format, ensuring each district name is unique
        const provinceOptions = _resDropShip
          .filter((district) => {
            const isUnique = !uniqueDistricts.has(district?.dristric?.dr_id);
            uniqueDistricts.add(district?.dristric?.dr_id); // Add the district name to the set
            return isUnique;
          })
          .map((district) => {
            return {
              value: district?.dristric?.dr_id, //district.id,
              label: district?.dristric?.dr_name, //district.dristric,
            };
          });

        // Set the district options
        // setDistrictOption(provinceOptions);
        setDesDistrictOption(provinceOptions);
        setMixayDropShipByProvince(_resDropShip);
      }
    } catch (error) {
      console.log("Error in handleMixayDropShip:", error);
      return errorSwal("ພົບຂໍ້ຜີດຜາດ ບໍ່ພົບຂໍມູນສາຂາ");
    }
  };

  // const filtDropshipOnProvince = (_keyFilter) => {
  //     const _dropShipOptions = prepareMixayDropships.filter((data) => {
  //         return data?.dristric === _keyFilter;
  //     });

  //     if (!_.isEmpty(_dropShipOptions)) {
  //         const _branchOption = _dropShipOptions.reduce((options, branch) => {
  //             options.push({
  //                 value: branch.code,
  //                 label: branch.village,
  //             });
  //             return options;
  //         }, []);
  //         setDesVillageOption(_branchOption);
  //         setBranchOption(_dropShipOptions);
  //     }
  // };
  // filter branch in province for mixay
  const handleMixayDistrict = (_keyFilter) => {
    const _dropShipOptions = mixayDropShipByProvince.filter((data) => {
      return data?.dristric?.dr_id === _keyFilter;
    });

    if (!_.isEmpty(_dropShipOptions)) {
      const _branchOption = _dropShipOptions.reduce((options, branch) => {
        options.push({
          value: branch?.code,
          label: branch?.name,
          // label: branch?.village?.vill_name,
        });
        return options;
      }, []);
      setDesVillageOption(_branchOption);
      setBranchOption(_dropShipOptions);
    }
  };

  // select destination province to filter district alls
  const onChangeDesProvince = (value) => {
    setDestinationAddress((prevState) => ({
      ...prevState,
      desProvince: value?.label,
    }));
    setIsCorrectBranchOption((prev) => ({ ...prev, pv: true }));
    setDesDistrictOption([]);
    // new
    switch (activeLogictics) {
      case HAL_KEY:
      case JNT_KEY:
        // HAL กับ JNT ใช้โครงเดียวกัน — กรอง districts ด้วย province_id
        const _districtOptions = logicticsAddress?.districts.filter(
          (data) => data?.province_id === value?.value,
        );
        const provinceOptions = _districtOptions.map((district) => ({
          value: district.id,
          label: district.name,
        }));

        setDesDistrictOption(provinceOptions);
        break;

      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        // handleFectMixayDropshipAll(value?.label);
        handleMixayDropShip(value?.value);
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  };

  // select district to filter branch alls
  const onChangeDistrict = async (value) => {
    if (!logicticsAddress?.branchDatas || !value) return;

    const _villageOptions = logicticsAddress.branchDatas.filter((data) => {
      return Number(data?.district_id) === Number(value?.value);
    });

    const _branchOption = _villageOptions.map((branch) => ({
      value: branch.id,
      label: branch.name,
    }));
    setVillageOption(_branchOption);
    setFormState((prevState) => ({
      ...prevState,
      _district: value?.label,
    }));
    setIsValidate((preError) => ({
      ...preError,
      errorReceivePro: false,
    }));
    setIsCorrectBranchOption((prev) => ({ ...prev, dt: true }));
  };

  // selelct destination district to filter branch all
  const onChangeDesDistrict = async (value) => {
    if (!logicticsAddress?.branchDatas || !value) return;

    setIsValidate((preError) => ({
      ...preError,
      errorReceiveDis: false,
    }));

    setDestinationAddress((prevState) => ({
      ...prevState,
      desDistrict: value?.label,
    }));

    setIsCorrectBranchOption((prev) => ({ ...prev, dt: true }));

    // new
    switch (activeLogictics) {
      case JNT_KEY: {
        const _jntBranches = logicticsAddress.branchDatas.filter(
          (data) => String(data?.district_id) === String(value?.value),
        );

        setDesVillageOption(
          _jntBranches.map((branch) => ({
            value: branch.id,
            label: branch.name,
          })),
        );

        setIsCorrectBranchOption((prev) => ({ ...prev, br: false }));
        setDestinationAddress((prevState) => ({ ...prevState, desBranch: "" }));
        setHealthCheck((prev) => ({ ...prev, 4: false }));
        break;
      }

      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        // filtDropshipOnProvince(value?.label);
        handleMixayDistrict(value?.value);
        break;

      case HAL_KEY:
        // Handle HAL_KEY logic
        const _villageOptions = logicticsAddress.branchDatas.filter((data) => {
          return Number(data?.district_id) === Number(value?.value);
        });

        const _branchOption = _villageOptions.map((branch) => ({
          value: branch.id,
          label: branch.name,
        }));

        setDesVillageOption(_branchOption);
        // setDestinationAddress((prevState) => ({
        //     ...prevState,
        //     desDistrict: value?.label,
        // }));
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  };

  // Select branch data
  const onChangeBranch = (value) => {
    setFormState((prevState) => ({
      ...prevState,
      _branchName: JSON.stringify(value),
    }));
    setIsCorrectBranchOption((prev) => ({ ...prev, br: true }));
  };

  // On select destination branch
  const onChangeDesBranch = (value) => {
    setDestinationAddress((prevState) => ({
      ...prevState,
      desBranch: JSON.stringify(value),
    }));
    setIsValidate((preError) => ({
      ...preError,
      errorReceiveBranch: false,
    }));

    setIsCorrectBranchOption((prev) => ({ ...prev, br: true }));

    if (healthCheck[3] && (!_.isEmpty(value) || isReceiveAddress)) {
      setHealthCheck((prev) => ({ ...prev, 4: true }));
    }

    // new code
    if (activeLogictics === MIXAY_KEY) {
      const newBranch = branchOption.filter((b) => {
        return b.code === value?.value;
      });
      setFormState((prevState) => ({
        ...prevState,
        _branchName: JSON.stringify(value),
        branchOption: newBranch[0],
      }));
    }
  };

  // select delivery default for shop
  const onSelectDelivery = (item) => {
    setDeliveryData(item);
    setIsValidate((preError) => ({
      ...preError,
      errorSenderAddress: false,
    }));
    setDesProvinceOption([]);
    setDesDistrictOption([]);
    setDesVillageOption([]);
    setActiveLogictics(item?.deliveryName);
    setIsCorrectBranchOption({ pv: false, dt: false, br: false });
    switch (item?.deliveryName) {
      case HAL_KEY:
        getHalBranchDatas();
        if (settingData?.halIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      case MIXAY_KEY:
        // getMixayProvinces();
        getMixayProvincesV2();
        if (settingData?.mxIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      case JNT_KEY:
        getJntProvinces();
        if (settingData?.jntIsOpen) setDisabledSave(false);
        else setDisabledSave(true);
        break;
      default:
        break;
    }
    setHealthCheck((prev) => ({ ...prev, 2: true, 3: true }));
  };

  const handleCloseConfirmOrderDelivery = () => {
    setDeliveryData({
      id: "",
      deliveryName: "",
    });
    onCloseSelectModal();
    setCompletedPreOrder({
      status: false,
      isError: false,
      message: "",
    });
    setIsAddAddress(false);
    setIsValidate({
      errorSenderAddress: false,
      errorReceivePro: false,
      errorReceiveDis: false,
      errorReceiveBranch: false,
    });
    setIsMatchDelivery({
      match: false,
      addressReceiver: {},
    });
    setShipmentPayType("CDC");
    setHealthCheck((prev) => ({ ...prev, 2: false, 3: false, 4: false }));
    setIsReceiveAddress(false);
  };

  const handleReceiveAddress = () => {
    const isMatchReceive =
      isMatchDelivery?.match &&
      !_.isEmpty(isMatchDelivery?.addressReceiver?.province) &&
      !_.isEmpty(isMatchDelivery?.addressReceiver?.district) &&
      !_.isEmpty(isMatchDelivery?.addressReceiver?.branch);
    if (isMatchReceive) {
      setIsCorrectBranchOption({ pv: false, dt: false, br: false });
    }
    setIsReceiveAddress(isMatchReceive);
  };

  return (
    <Modal
      show={openSelect}
      onHide={handleCloseConfirmOrderDelivery}
      centered
      size="lg"
    >
      <Modal.Body closeButton>
        {completedPreOrder?.status ? (
          <div
            className="d-flex justify-content-center align-items-center flex-column"
            style={{ minHeight: 400 }}
          >
            <h3 style={{ fontSize: 28, fontWeight: "bold" }}>
              {completedPreOrder?.message}
            </h3>
            <p>ອໍເດີ້ນີ້ຖຶກສ້າງເປັນບິນເບື້ອງຂົນສົ່ງແລ້ວ</p>

            <Button onClick={handleCloseConfirmOrderDelivery} variant="success">
              ກົດ ເພື່ອປີດອອກ
            </Button>
          </div>
        ) : (
          <Formik
            initialValues={{
              shopName: shopData?.name,
              shopPhone: shopData?.phone,
              logistics: null,
              receiverLogictics: null,
              receiverName:
                orderGroupdataProps?.cfName ??
                orderGroupdataProps?.customerName ??
                "",
              receiverPhone:
                orderGroupdataProps?.orderDelivery?.receiver?.tel ??
                orderGroupdataProps?.phone ??
                "",
              length: "10",
              width: "10",
              height: "10",
              weight: "0.5",
            }}
            validationSchema={!isAddAddresss ? validationSchema : null}
            onSubmit={(values) => {
              confirmPreOrders(values);
            }}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div>
                  <h4>
                    1.{" "}
                    {isAddAddresss
                      ? "ສ້າງຂໍ້ມູນຕົ້ນທາງໃໝ່"
                      : "ເລືອກຕົ້ນທາງ ແລະ ຂໍ້ມູນຜູ້ຝາກ"}
                  </h4>
                </div>
                {isAddAddresss ? (
                  <div>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>ຂົນສົ່ງ</Form.Label>
                          <Select
                            options={enabledLogicsticsOptions}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, setFieldValue)
                            }
                            placeholder="-ເລືອກ-"
                            value={values.logistics}
                          />
                          <ErrorMessage
                            name="logistics"
                            component="small"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            ແຂວງ{" "}
                            {(loadingBanchHal ||
                              loadingProvinceMixayV2 ||
                              loadingProvinceJnt) && (
                              <Spinner size="sm" animation="grow" />
                            )}
                          </Form.Label>
                          <Select
                            options={provinceOption}
                            onChange={onChangeProvince}
                            placeholder="-ເລືອກ-"
                            value={values.name}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            ເມືອງ
                            {(loadingProvinceMixayV2 || loadingProvinceJnt) && (
                              <Spinner size="sm" animation="grow" />
                            )}
                          </Form.Label>
                          <Select
                            options={districtOption}
                            onChange={onChangeDistrict}
                            placeholder="-ເລືອກ-"
                            value={values.name}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>ສາຂາ</Form.Label>
                          <Select
                            options={villageOption}
                            onChange={onChangeBranch}
                            placeholder="-ເລືອກ-"
                            value={values.name}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label>ຊື່ຜູ້ຝາກ ຫຼື ຊື່ຮ້ານ</Form.Label>
                      <Field
                        name="shopName"
                        className="form-control"
                        type="text"
                        placeholder="ປ້ອນຊື່ຜູ້ຝາກ"
                      />
                      <ErrorMessage
                        name="shopName"
                        component="small"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>ເບີໂທຜູ້ຝາກ</Form.Label>
                      <Field
                        name="shopPhone"
                        className="form-control"
                        type="text"
                        placeholder="ປ້ອນເບີໂທຜູ້ຝາກ"
                      />
                      <ErrorMessage
                        name="shopPhone"
                        component="small"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                ) : (
                  <div>
                    <ListGroup as="ol">
                      {depositorDatas.map((item, _index) => (
                        <ListGroup.Item
                          key={_index}
                          style={{
                            border: `1px solid ${isValidate?.errorSenderAddress ? "red" : "#dddd"}`,
                            background:
                              deliveryData?.id === item?.id
                                ? "#f2f2f2"
                                : "#ffffff",
                          }}
                          as="li"
                          className="d-flex justify-content-between align-items-start"
                          disabled={
                            !item?.dropship_end &&
                            item?.deliveryName === "MIXAY"
                              ? true
                              : false
                          }
                        >
                          <div className="ms-2 me-auto">
                            <div style={{ fontWeight: "bold" }}>
                              <img
                                src={checkLogoLogictics(item?.deliveryName)}
                                alt={item?.deliveryName}
                                style={{
                                  width: 40,
                                  height: 40,
                                  overflow: "hidden",
                                  borderRadius: "40em",
                                  marginRight: 5,
                                }}
                              />
                              {convertLogicticsName(item?.deliveryName)}{" "}
                            </div>
                            <div>
                              <p>
                                ຜູ້ຝາກ: {item?.fullName ?? item?.shopName},
                                ເບີໂທຜູ້ຝາກ: {item?.shopTel ?? "-"}
                              </p>
                              <p>
                                ຕົ້ນທາງ: ແຂວງ{" "}
                                {item?.province +
                                  ", ເມືອງ " +
                                  item?.district +
                                  ", ສາຂາ " +
                                  item?.branch}{" "}
                              </p>
                            </div>
                          </div>
                          <Button
                            onClick={() => onSelectDelivery(item)}
                            style={{
                              borderRadius: "50em",
                              width: 40,
                              height: 40,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            variant={
                              deliveryData?.id === item?.id
                                ? "success"
                                : "outline-success"
                            }
                            disabled={
                              !item?.dropship_end &&
                              item?.deliveryName === "MIXAY"
                                ? true
                                : false
                            }
                          >
                            {deliveryData?.id === item?.id ? (
                              <MdOutlineCheckCircle style={{ fontSize: 32 }} />
                            ) : (
                              <MdRadioButtonChecked style={{ fontSize: 32 }} />
                            )}
                          </Button>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>

                    {/* //TODO [2] */}
                    {healthCheck?.[2] && (
                      <div className="my-4">
                        <h4>2. ເລືອກປະເພດການເກັບເງິນ</h4>
                        <div className="d-flex gap-2">
                          {_.isEmpty(shipmentPayType) ? (
                            setShipmentPayType("CDC")
                          ) : (
                            <>
                              <Button
                                className="w-100 py-2"
                                variant={
                                  shipmentPayType === "CDC"
                                    ? "success"
                                    : "outline-secondary"
                                }
                                onClick={() => setShipmentPayType("CDC")}
                              >
                                ເກັບຄ່າຂົນສົ່ງປາຍທາງ CDC
                              </Button>
                              <Button
                                className="w-100 py-2"
                                variant={
                                  shipmentPayType === "FREE"
                                    ? "success"
                                    : "outline-secondary"
                                }
                                onClick={() => setShipmentPayType("FREE")}
                              >
                                ເກັບຄ່າຂົນສົ່ງຕົ້ນທາງ
                              </Button>

                              {/* //* Validation COD */}
                              {settingData?.logisticsCOD && (
                                <Button
                                  className="w-100 py-2"
                                  variant={
                                    shipmentPayType === "COD"
                                      ? "success"
                                      : "outline-secondary"
                                  }
                                  onClick={() => setShipmentPayType("COD")}
                                >
                                  ເກັບຄ່າຂົນສົ່ງ ແລະ ຄ່າເຄື່ອງປາຍທາງ COD
                                </Button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {/*  //TODOD [3] */}
                    {healthCheck?.[3] && (
                      <div className="mt-4">
                        <h4>3. ຂໍ້ມູນປາຍທາງ </h4>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ຊື່ຜູ້ຮັບ</Form.Label>
                              <Field
                                name="receiverName"
                                className="form-control"
                                type="text"
                                placeholder="ປ້ອນຊື່ຜູ້ຝາກ"
                              />
                              <ErrorMessage
                                name="receiverName"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ເບີໂທຜູ້ຮັບ</Form.Label>
                              <Field
                                name="receiverPhone"
                                className="form-control"
                                type="text"
                                placeholder="ປ້ອນຊື່ຜູ້ຝາກ"
                              />
                              <ErrorMessage
                                name="receiverPhone"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        {isReceiveAddress ? (
                          <Row>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>ແຂວງ</Form.Label>
                                <Form.Control
                                  type="text"
                                  defaultValue={
                                    isMatchDelivery?.addressReceiver?.province
                                  }
                                  aria-label="Disabled input example"
                                  disabled
                                  readOnly
                                />
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>ເມືອງ</Form.Label>
                                <Form.Control
                                  type="text"
                                  defaultValue={
                                    isMatchDelivery?.addressReceiver?.district
                                  }
                                  aria-label="Disabled input example"
                                  disabled
                                  readOnly
                                />
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>ສາຂາ</Form.Label>
                                <Form.Control
                                  type="text"
                                  defaultValue={
                                    isMatchDelivery?.addressReceiver?.branch
                                  }
                                  aria-label="Disabled input example"
                                  disabled
                                  readOnly
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        ) : (
                          <Row>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  ແຂວງ{" "}
                                  {(loadingBanchHal ||
                                    loadingProvinceMixayV2 ||
                                    loadingProvinceJnt) && (
                                    <Spinner size="sm" animation="grow" />
                                  )}
                                </Form.Label>
                                <Select
                                  options={desProvinceOption}
                                  onChange={onChangeDesProvince}
                                  placeholder="-ເລືອກ-"
                                  value={values.name}
                                />
                                {/* ⚠️ ເມື່ອກ່ອນໃຊ້ <ErrorMessage> ຂອງ Formik ບ່ອນນີ້ ຊຶ່ງບໍ່ເຄີຍ
                                    ຂຶ້ນເລີຍ: ມັນຂຶ້ນສະເພາະເມື່ອ Formik ມີ touched+errors
                                    ຂອງ field ນັ້ນ ແຕ່ desProvince/desDistrict/desBranch
                                    ບໍ່ໄດ້ຢູ່ໃນ initialValues ຫຼື validationSchema ເລີຍ
                                    (ຊ້ຳ Formik ຍັງຖິ້ມ children ທີ່ເປັນ string ອີກ —
                                     ມັນ render ຂໍ້ຄວາມ error ຂອງ Formik ແທນ)
                                    ໃຊ້ <small> ທຳມະດາ ເພາະ isValidate ຄຸມການໂຊຢູ່ແລ້ວ */}
                                {isValidate?.errorReceivePro && (
                                  <small className="text-danger">
                                    ເລືອກແຂວງກ່ອນ!
                                  </small>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  ເມືອງ
                                  {loadingDropShipMixayV2 && (
                                    <Spinner size="sm" animation="grow" />
                                  )}
                                </Form.Label>
                                <Select
                                  options={desDistrictOption}
                                  onChange={onChangeDesDistrict}
                                  placeholder="-ເລືອກ-"
                                  value={values.name}
                                />
                                {isValidate?.errorReceiveDis && (
                                  <small className="text-danger">
                                    ເລືອກເມືອງກ່ອນ!
                                  </small>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label>ສາຂາ</Form.Label>
                                <Select
                                  options={desVillageOption}
                                  onChange={onChangeDesBranch}
                                  placeholder="-ເລືອກ-"
                                  value={values.name}
                                />
                                {isValidate?.errorReceiveBranch && (
                                  <small className="text-danger">
                                    ເລືອກສາຂາກ່ອນ!
                                  </small>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        )}
                      </div>
                    )}

                    {/* //TODO [4] */}
                    {healthCheck[4] && (
                      <div className="mt-4">
                        <h4>4. ຂະຫນາດພັດສະດຸ</h4>
                        <p style={{ color: "red" }}>
                          ກະລຸນາປ້ອນຂໍ້ມູນທີ່ເປັນຈີ່ງ(ເພາະສ່ຽງຕໍ່ການຖືກແບນຫາກໃຫ້ຂໍ້ມູນທີ່ບໍ່ເປັນຈີ່ງ)
                        </p>
                        <p>ຄ່າເລີ່ມຕົ້ນສຳລັບຂະຫນາດພັດທີ່ຈະຈັດສົ່ງ:</p>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ນ້ຳຫນັກ</Form.Label>
                              <Field
                                maxLength={4}
                                pattern="[0-9]{4}"
                                name="weight"
                                className="form-control"
                                type="text"
                                placeholder="kg..."
                              />
                              <ErrorMessage
                                name="weight"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ຄວາມຍາວ</Form.Label>
                              <Field
                                maxLength={4}
                                pattern="[0-9]{4}"
                                name="length"
                                className="form-control"
                                type="text"
                                placeholder="cm..."
                              />
                              <ErrorMessage
                                name="length"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ຄວາມກວ້າງ</Form.Label>
                              <Field
                                maxLength={4}
                                pattern="[0-9]{4}"
                                name="width"
                                className="form-control"
                                type="text"
                                placeholder="cm..."
                              />
                              <ErrorMessage
                                name="width"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>ຄວາມສູງ</Form.Label>
                              <Field
                                maxLength={4}
                                pattern="[0-9]{4}"
                                name="height"
                                className="form-control"
                                type="text"
                                placeholder="cm..."
                              />
                              <ErrorMessage
                                name="height"
                                component="small"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}

                {completedPreOrder?.isError && (
                  <Alert
                    variant="danger"
                    onClose={() => setCompletedPreOrder({ isError: false })}
                    dismissible
                  >
                    <Alert.Heading>ເກີດຂໍ້ຜິດພາດ!</Alert.Heading>
                    <p>
                      {completedPreOrder?.message ===
                      "SORRY_SHOP_DELIVERY: MIXAY_IS_TURN_OFF"
                        ? "ກະລຸນາເປີດຂົນສົ່ງຢູ່ຕັ້ງຄ່າກ່ອນ"
                        : completedPreOrder?.message}
                    </p>
                  </Alert>
                )}
                {healthCheck[4] && (
                  <div className="d-flex justify-content-end gap-4 mt-4">
                    <Button
                      type="button"
                      variant="light"
                      style={{ padding: 10, minWidth: 180 }}
                      onClick={handleCloseConfirmOrderDelivery}
                    >
                      <MdCancel /> ຍົກເລີກ
                    </Button>

                    <Button
                      type="submit"
                      style={{
                        background: COLOR_APP,
                        padding: 10,
                        minWidth: 180,
                      }}
                      // disabled={isAddAddresss ? loadingAddShopAddresss : loadingCreatePreOrder}
                      disabled={
                        disabledSave
                          ? true
                          : isAddAddresss
                            ? loadingAddShopAddresss
                            : loadingCreatePreOrder
                      }
                      // onClick={handleSubmit}
                    >
                      {isAddAddresss ? (
                        loadingAddShopAddresss ? (
                          <>
                            <Spinner size="sm" /> ກຳລັງສ້າງ...
                          </>
                        ) : (
                          <>
                            <FaSave /> ບັນທຶກ
                          </>
                        )
                      ) : loadingCreatePreOrder ? (
                        <>
                          <Spinner size="sm" /> ກຳລັງສ້າງ...
                        </>
                      ) : (
                        <>
                          <FaSave /> ຢືນຢັນຈັດສົ່ງ
                        </>
                      )}
                    </Button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  );
}

const logicsticsOptions = [
  {
    value: LOGISTICS_DATAS?.mixay?.keyDefault,
    label: (
      <div>
        <img
          style={{ width: 20, height: 20, marginRight: 10, borderRadius: 5 }}
          src={LOGISTICS_DATAS?.mixay?.image}
          alt={LOGISTICS_DATAS?.mixay?.keyDefault}
        />
        {LOGISTICS_DATAS?.mixay?.name}
      </div>
    ),
  },

  {
    value: LOGISTICS_DATAS?.hal?.keyDefault,
    label: (
      <div>
        <img
          style={{
            width: 20,
            height: 20,
            marginRight: 10,
            borderRadius: "40em",
          }}
          src={LOGISTICS_DATAS?.hal?.image}
          alt={LOGISTICS_DATAS?.hal?.keyDefault}
        />
        {LOGISTICS_DATAS?.hal?.name}
      </div>
    ),
  },

  {
    value: LOGISTICS_DATAS?.jnt?.keyDefault,
    label: (
      <div>
        <img
          style={{
            width: 20,
            height: 20,
            marginRight: 10,
            borderRadius: "40em",
          }}
          src={LOGISTICS_DATAS?.jnt?.image}
          alt={LOGISTICS_DATAS?.jnt?.keyDefault}
        />
        {LOGISTICS_DATAS?.jnt?.name}
      </div>
    ),
  },

  {
    value: LOGISTICS_DATAS?.anusith?.keyDefault,
    label: (
      <div>
        <img
          style={{
            width: 20,
            height: 20,
            marginRight: 10,
            borderRadius: "40em",
          }}
          src={LOGISTICS_DATAS?.anusith?.image}
          alt={LOGISTICS_DATAS?.anusith?.keyDefault}
        />
        {LOGISTICS_DATAS?.anusith?.name}
      </div>
    ),
  },
];
